// extracted by mini-css-extract-plugin
module.exports = {"register-success":"DocumentsValidation_register-success__zri5y","icon-big":"DocumentsValidation_icon-big__zpgQ2","text":"DocumentsValidation_text__HH5qc"};